import React from "react";
import { CopyOutlined } from "@ant-design/icons";
import { message } from 'antd';
var Clipboard = function (props) {
    var value = props.value, className = props.className, color = props.color, fontSize = props.fontSize, successMessage = props.successMessage;
    return (React.createElement(CopyOutlined, { style: { fontSize: fontSize, color: color }, className: "mgl5 mgr5 _btCopy " + className, onClick: function () {
            var textField = document.createElement('textarea');
            textField.innerText = value ? value.toString() : '';
            document.body.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            textField.remove();
            message.success(successMessage ? successMessage : 'Copied');
        } }));
};
Clipboard.defaultProps = {
    color: 'gray',
    fontSize: 16
};
export default Clipboard;
